<div class="angaben__group">
    Ich bestätige, dass ich zur Antragstellung handlungsbefugt und berechtigt bin.
    Die vorstehenden Fragen wurden vollständig und nach bestem Wissen und Gewissen beantwortet. Die Angaben entsprechen dem derzeitigen Stand.
    Außerdem bin ich damit einverstanden, dass digitale Bürgschaften von der VHV dem Auftraggeber auf der Serviceplattform der
    Trustlog GmbH, Heidenkampsweg 100, 20097 Hamburg, zur Verfügung gestellt werden, sofern sich der
    Auftraggeber dort für die Verwendung von digitalen Bürgschaften registriert hat.
    Die aktuellen Allgemeinen Versicherungsbedingungen
    für die Kautionsversicherung und die aktuellen Nutzungsbedingungen für das VHV Kreditportal erkenne(n) ich/wir an.
</div>

@if (canShowItemMultipleInputs(model.erklaerungsOrt, model.erklaerungsDatum)) {
    <div class="angaben__group">
        <div class="angaben__label">Ort und Datum</div>
        <div class="angaben__value">{{ model.erklaerungsOrt.value }}, {{ model.erklaerungsDatum.value }}</div>
    </div>
}

@if (canShowItem(model.erklaerungsName)) {
    <div class="angaben__group">
        <div class="angaben__label">Name</div>
        <div class="angaben__value">{{ model.erklaerungsName.value }}</div>
    </div>
}
